<template>
    <div id="mysidebar">
      <aside
        v-for="(aside,index) in cleanWidgets"
        :key="index"
      >
        <a :href="aside.a.attr.href">
            <img v-if="aside.a.img"
              :src="aside.a.img.attr.src"
              :height="aside.a.img.attr.height"
              :width="aside.a.img.attr.width"
              :srcset="aside.a.img.attr.srcset"
              :sizes="aside.a.img.attr.sizes"
              :style="aside.a.img.attr.atyle"
            />
        </a>
      </aside>
    </div>
</template>
<script>
import helper from "@/helper.js";

export default {
    name: 'SideBar',
    data: () => {
      return {
        mySideBar: {},
      }
    },
    mounted () {
      this.getSideBar();
    },
    watch: {
      mySideBar: function () {
        // console.log("output watcher: " + this.$el.innerHTML);
      }
    },
    computed: {
      cleanWidgets: function() {
        let arr = this.mySideBar;
        let obj=[];
        for (let i=0; i<arr.length; i++) {
          if (typeof arr[i].a !== 'undefined') {
            obj.push(arr[i]);
          }
        }
        // console.log( JSON.stringify(obj,null, 4) );
        return obj;
      }
    },
    methods: {
      getSideBar (){
        //console.log("window.location.pathname: " + window.location.pathname);
        this.$http.get(
          '/getsidebar/v1/all' )
        .then( (response) => {
          let myData = JSON.stringify(response.data.aside);
          myData= myData.replaceAll("@attributes", "attr");
          // console.log(myData);
          this.mySideBar = JSON.parse(myData);
          // console.log("mysidebar" + response.data);
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

  };

</script>
